<div class="model-fit-progress">
  <div class="metric-row top-value">
    <div class="marker-label" [style.left.%]="topValuePosition">
      <span class="tick-marker"></span>
      <div class="metric-label text-gray-1000" [ngClass]="topLabelClass">
        <span class="b1">{{ topLabel }}: </span>
        <span class="b2">{{ formatPercent(topValue) }}</span>
      </div>
    </div>
  </div>

  <div class="progress-track">
    <div
      class="progress-zone low-risk"
      [style.width.%]="thresholdPosition"></div>
    <div
      class="progress-zone in-range"
      [style.left.%]="thresholdPosition"
      [style.width.%]="cutoffPosition - thresholdPosition"></div>
    <div
      class="progress-zone high-risk"
      [style.left.%]="cutoffPosition"
      [style.width.%]="100 - cutoffPosition"></div>
  </div>

  <div class="axis-labels">
    @for (axis of axisLabels; track axis.value) {
      <span
        class="axis-label c1 text-gray-800"
        [style.left.%]="axisPosition(axis.value)">
        {{ axis.label }}
      </span>
    }
  </div>

  @if (showBottomValue) {
    <div class="metric-row bottom-value">
      <div class="marker-label" [style.left.%]="bottomValuePosition">
        <span class="tick-marker"></span>
        <div class="metric-label text-gray-1000" [ngClass]="bottomLabelClass">
          <span class="b1">{{ bottomLabel }}: </span>
          <span class="b2">{{ formatPercent(bottomValue) }}</span>
        </div>
      </div>
    </div>
  }
</div>
